<div class="container-fluid" *ngIf="!vm.isOpening">
  <core-spinner *ngIf="vm.isLoading"></core-spinner>

  <cli-landing-header></cli-landing-header>

  <div class="row">
    <div class="col-xl-2 col-lg-1 "></div>
    <div class="col-xl-2 col-lg-2 col-md-3  pt-4">
      <cli-landing-menu></cli-landing-menu>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-5 ">

      <div class="mt-2 mb-4 row">
        <div class="col welcome-text text-center">Reset Hydrotrak Password</div>
      </div>


      <div class="mt-2 mb-4 row">
        <div class="col d-flex justify-content-center">
          <div style="width:300px;">
            <form>
              <div *ngIf="vm.isValidated && !vm.isSubmitted">
                <div class="row pb-1">
                  <div class="col">
                    <label>User Name</label>
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('userName')}" name="userName"
                      placeholder="Email Address" type="email" [(ngModel)]="vm.userName" [readonly]="true">
                  </div>
                </div>
                <div class="row pb-1">
                  <div class="col">
                    <label>Password</label>
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password"
                      placeholder="" type="password" [(ngModel)]="vm.password">
                    <div class="invalid-feedback"> {{error('password')}} </div>
                  </div>
                </div>
                <div class="row pb-1">
                  <div class="col">
                    <label>Confirm Password</label>
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('confirmPassword')}"
                      name="confirmPassword" placeholder="" type="password" [(ngModel)]="vm.confirmPassword">
                    <div class="invalid-feedback"> {{error('confirmPassword')}} </div>
                  </div>
                </div>



                <div class="mt-4 mb-2 row">
                  <div class="col text-center">

                    <button class="btn  btn-primary" style="width:150px;" (click)="submit()">Submit</button>

                  </div>
                </div>



              </div>

            </form>
          </div>
        </div>
      </div>

      <div *ngIf="!vm.isValidated"  class="alert alert-danger text-center">
         Sorry, we cannot recognise this Hydrotrak link
      </div>

      <div *ngIf="vm.isValidated && !vm.isSubmitted" class="mt-4 mb-2 row">
        <div class="col text-center">Please specify your new password and click submit</div>
      </div>

      <div *ngIf="vm.isValidated && vm.isSubmitted" class="alert alert-info text-center">
        The password was successfully updated. Please use the link to <a routerLink="../../login">login</a> to Hydrotrak.
      </div>
      
    </div>
    <div class="col-xl-2 col-lg-2 col-md-3"></div>
    <div class="col-xl-2 col-lg-1 "></div>
  </div>


  <div style="padding-bottom:100px"></div>
  <cli-landing-footer></cli-landing-footer>

</div>